import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { useDispatch, useSelector } from 'react-redux';
import IcomoonReact from 'icomoon-react';

import Text from '../../../../shared/components/Text/Text';
import Button from '../../../../shared/components/Button/Button';
import { downloadActivityReport } from '../../ducks/reportingActions';
import iconSet from '../../../../shared/images/teambuildr-selection.json';

const NavigationWrapper = styled('div')`
  display: flex;
  width: 100%;
  margin-bottom: -20px;
  z-index: 1;
  position: absolute;
  top: 0px;
  left: 0px;
  padding: 20px;

  .arrow-div {
    cursor: pointer;

    &.back {
      justify-self: flex-start;
    }
    &.close {
      justify-self: flex-end;
      margin-left: auto;
    }
  }
`;

const DownloadActivityReport = ({
  closeModal,
}) => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const sidebarFilter = useSelector((state) => state.reporting.data.sidebarFilter);

  const dispatch = useDispatch();
  const { accountCode } = currentUser;

  const fetchReport = () => {
    dispatch(downloadActivityReport(sidebarFilter, accountCode));
  };

  const DownloadData = () => {
    fetchReport();
    closeModal();
  };

  return (
    <>
      <NavigationWrapper>
        <Text
          className='close arrow-div'
          onClick={() => {
            closeModal();
          }}
        >
          <IcomoonReact
            iconSet={iconSet}
            size={13}
            icon='remove'
          />
        </Text>
      </NavigationWrapper>
      <Text
        fontSize='18px'
        textAlign='center'
      >
        Would you like to download this activity report as a CSV File?
      </Text>
      <Button
        cta='Download Report'
        className='modal-button'
        type='button'
        onClick={DownloadData}
        fullWidth
        noBorder
        large
        square
        primary
        bottom
      />
    </>
  );
};

DownloadActivityReport.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default DownloadActivityReport;
